/**
* @ComponentFor Avensia.Shop.Features.Shared.Blocks.FooterLink.FooterLinkBlockViewModel
*/
import React from 'react';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import * as styles from './base.scss';
import Button from 'Shared/Button';
import { translate } from 'Shared/translate';
export default (props) => {
    return (props.targetPageUrl && (React.createElement("div", { className: styles.base },
        React.createElement("div", null,
            React.createElement("div", { className: styles.h3 }, epiPropertyValue(props.block.title)),
            React.createElement("p", { className: styles.paragraph }, epiPropertyValue(props.block.subTitle))),
        React.createElement(Button, { href: props.targetPageUrl, appearance: "toolbarbutton" }, translate("/Shared/ReadMore")))));
};
